export const XBadge = ({ children }: { children: React.ReactNode }) => {
  return (
    <div style={{ position: "absolute", top: 0, right: 0 }}>
      <div
        style={{
          marginTop: "-50%",
          marginRight: "-50%",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        {children}
      </div>
    </div>
  );
};
